import { render, staticRenderFns } from "./CoRef.vue?vue&type=template&id=ab389fca&"
import script from "./CoRef.vue?vue&type=script&lang=js&"
export * from "./CoRef.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports